/**
 * Sticky header
 *
 * Handles the header becoming sticky after scrolling past the fold.
 *
 * @param  $
 */
( function( $ ) {
	var lastScrollTopValue = 0;
	var header = '.site-header';
	if ( $( header ).length ) {
		$( header ).addClass( 'sticky-header' );
		$( 'body' ).addClass( 'sticky-header-active' );

		calculateHeader();
		$( window ).scroll( calculateHeader );
	}

	function calculateHeader() {
		var headerHeight = $( header ).height();
		var currentScrollTop = $( this ).scrollTop();

		hideHeader( headerHeight, false );

		/**
		 * If we have scrolled below the fold, add the sticky header class.
		 * This will 'stick' the header, but will not display it until the user scrolls up (next conditional handles this below)
		 */
		if ( currentScrollTop >= headerHeight ) {
			hideHeader( headerHeight, true );

			/**
			 * Show the menu only when we scroll up, and we are below the fold.
			 */
			if ( currentScrollTop < lastScrollTopValue ) {
				showHeader( headerHeight, true );
			} else {
				hideHeader( headerHeight, false );
			}
		} else {
			showHeader( headerHeight, false );
		}
		lastScrollTopValue = currentScrollTop;
	}

	function shiftElementVertical( elementToShift, valueToShift, valuePrefix ) {
		$( elementToShift ).css( 'transform', 'translate3d(0px, ' + valuePrefix + valueToShift + 'px, 0px' );
	}

	function showHeader( headerHeight, isBelowFold ) {
		shiftElementVertical( header, 0, '' );
		if ( ! isBelowFold ) {
			$( 'body' ).css( 'margin-top', headerHeight );
		}
	}

	function hideHeader( headerHeight, isBelowFold ) {
		shiftElementVertical( header, headerHeight, '-' );
		if ( ! isBelowFold ) {
			$( 'body' ).css( 'margin-top', '0' );
		}
	}
}( jQuery ) );
